import { useColorModeValue } from "../components/ui/color-mode";

export const useSecondaryTextColor = () => {
  return useColorModeValue("gray.500", "gray.300");
};
